import React from 'react';
import { Separator } from "../Separator";
export var MenuSeparator = function MenuSeparator() {
  return /*#__PURE__*/React.createElement(Separator, {
    gap: 8
  });
};